// extracted by mini-css-extract-plugin
export default {"container":"BH-z","innerContainer":"CH-z","multipleLines":"DH-z","heading":"EH-z","content":"FH-z","linkColor":"GH-z"};